/**
 *
 * @param time api time format '00:00:00'
 */
export const StripMilliSecondsFromApiTime = (time: string): string => {
    return time.substring(0, time.lastIndexOf(':') ?? 0);
};
